import styled from 'styled-components';
import Button from 'react-bootstrap/Button';

export const Container = styled.div`
  &.Wrapper{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: #FFFFFF;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    border-radius: 10px;
    height: 250px;
    padding: 20px;
    cursor: pointer;
    position: relative;
    margin-bottom: 30px;
  }
  &.HoverAccount{
    position: relative;
  }
  &.HoverAccount:hover > .Wrapper{
    background: rgb(221,228,247);
  }
  &.HoverAccount:hover .DotsToSee{
    display: block;
  }
  &.DotsToSee{
    position: absolute;
    top: 20px;
    right: 15px;
  }
`;

export const StyledBtn = styled(Button)`
  &.Connect{
    width: 130px;
    height: 45px;
    background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    border-radius: 8px;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 136%;
    color: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity:1;
    border: none;
  }
  &.Connect:hover{
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    text-decoration: none;
    color: #FFFFFF;
  }
  &.Connect:focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
  &.Connect:active{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
  &.CommingSoon{
    font-family: NunitoSans, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 15px;
    line-height: 136%;
    text-align: center;
    color: #3B3C3E;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const GButton = styled(Button)`
  font-family: Roboto, sans-serif;
  font-weight: 600;
  background: #4285F4;
  border-radius: 2px;
  display: flex;
  //justify-content: space-between;
  align-items: center;
  padding: 2px;
  border-width: 0;
  &:hover{
    background: #4285F4;
    //background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  }
  &:focus{
    //background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-width: 0;
  }
  &:not(:disabled):not(.disabled):active:focus{
    //background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    border-width: 0;
  }
  & .logoContainer{
    height: 36px;
    width: 36px;
    border-radius: 2px;
    background: #ffffff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & span{
    flex: 1;
    padding: 0 24px;
  }
`

export const StyledLink = styled.a`
  width: 130px;
  border: none;
  height: 45px;
  opacity:1;
  background: linear-gradient(90.82deg, #1CCCEF -33.3%, #1C62EF 84.24%);
  border-radius: 8px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 136%;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover{
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
    text-decoration: none;
    color: #FFFFFF;
  }
  &:focus{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
  &:active{
    box-shadow: inset 4px 4px 4px rgba(0, 0, 0, 0.15);
    text-decoration: none;
    color: #FFFFFF;
  }
`;

export const NameContainer = styled.div`
  //overflow: hidden;
  display: flex;
  width: 100%;
  justify-content: center;
`

export const IndexingText = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 164%;
  text-align: center;
  margin-bottom: 0;
  color: #2C2B48;
`

export const StyledParagraph = styled.p`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 164%;
  text-align: center;
  color: #2C2B48;
`;

export const AccountName = styled.div`
  font-family: OpenSans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 164%;
  text-align: center;
  color: #2C2B48;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledImg = styled.img`
  width: 60px;
`;

export const Header3 = styled.h3`
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 22px;
  line-height: 152%;
  text-align: center;
  color: #2C2B48;
`;